import moment from 'moment'

export function humanize(duration) {
    if (duration && duration.asMilliseconds() > 0) {
        var format = []

        if (duration.years() > 0) {
            format.push(duration.years() + 'an')
        }
        if (duration.months() > 0) {
            format.push(duration.months() + 'mois')
        }
        if (duration.days() > 0) {
            format.push(duration.days() + 'j')
        }
        if (duration.hours() > 0) {
            format.push(duration.hours() + 'h')
        }
        if (duration.minutes() > 0) {
            format.push(duration.minutes() + 'min')
        }
        if (duration.seconds() > 0) {
            format.push(duration.seconds() + 's')
        }

        return format.slice(0, 2).join(' ')
    }
    return '---'
}

export function humanizeShort(duration) {
    if (duration && duration.asMilliseconds() > 0) {
        const locale = moment.localeData()

        const seconds  = Math.round(duration.as('s'))
        const minutes  = Math.round(duration.as('m'))
        const hours    = Math.round(duration.as('h'))
        const days     = Math.round(duration.as('d'))
        const months   = Math.round(duration.as('M'))
        const years    = Math.round(duration.as('y'))

        if (seconds < 120) return locale.relativeTime(seconds, true, 's')
        if (minutes <= 1) return locale.relativeTime(minutes, true, 'm')
        if (minutes < 120) return locale.relativeTime(minutes, true, 'mm')
        if (hours <= 1) return locale.relativeTime(hours, true, 'h')
        if (hours < 48) return locale.relativeTime(hours, true, 'hh')
        if (days <= 1) return locale.relativeTime(days, true, 'd')
        if (days < 60) return locale.relativeTime(days, true, 'dd')
        if (months <= 1) return locale.relativeTime(months, true, 'M')
        if (months < 24) return locale.relativeTime(months, true, 'MM')
        if (years <= 1) return locale.relativeTime(years, true, 'y')
        return locale.relativeTime(years, true, 'yy')
    }
    return 0
}

export function parseFormat(source, format) {
    // workaround when providing a parse format with a date to moment as it gives unexpected results
    if (source instanceof Date) return undefined
    return format
}


// WEBPACK FOOTER //
// ./lib/core/momentz.js